import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const LANDING_URL = 'https://e-chat.tech'

// cabinet locale -> landing locale prefix (the cabinet uses "ua", the landing "uk")
const LANDING_LOCALES = {
    ua: 'uk',
    ru: 'ru',
    en: 'en',
}

/**
 * Link to the landing page in the current cabinet language (CHAT-598).
 */
export const useLandingUrl = () => {
    const { locale } = useI18n()

    const landingUrl = computed(() => {
        const landingLocale = LANDING_LOCALES[locale.value] ?? LANDING_LOCALES.en

        return `${LANDING_URL}/${landingLocale}`
    })

    return { landingUrl }
}
